import 'react-toastify/dist/ReactToastify.css';

import { datadogRum } from '@datadog/browser-rum';
import {
  ExportDashboard,
  RelatedView,
  ResultsPage,
  ToastContainer,
  ViewDashboard,
} from 'components/core';
import {
  BrowserRouter,
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';
import { PACKAGE_NAME } from 'utils/constants';
import { PATHS } from 'utils/constants/Routes';
import {
  ColumnContextProvider,
  FilterContextProvider,
  ListContextProvider,
  ViewContextProvider,
} from 'utils/context';

import { RequireUserAndFlags } from '@project44/feature-flags';
import {
  Box,
  Provider as ManifestProvider,
  Toaster,
} from '@project44/manifest-ds';
import { Provider as DeprecatedThemeProvider } from '@project44/manifest-ui-deprecated';
import { ErrorPage, Loader } from '@project44/shared-components';
import { RequireTranslations } from '@project44/translations-utils';
import { useUserTracking } from '@project44/ui-utils';

import translations from '../l10n/config';

function ShipmentListRoutes() {
  const { location } = useHistory();
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Redirect
        from="/:url*(/+)"
        to={{
          ...location,
          pathname: location.pathname.slice(0, -1),
        }}
      />
      <Route path={`${path}/${PATHS.exportFile}`}>
        <FilterContextProvider>
          <ExportDashboard />
        </FilterContextProvider>
      </Route>
      <Route path={`${path}/dashboard`}>
        <ListContextProvider>
          <ViewContextProvider>
            <ViewDashboard />
          </ViewContextProvider>
        </ListContextProvider>
      </Route>
      <Route path={`${path}/${PATHS.relatedView}`}>
        <RelatedView />
      </Route>
      <Route path={path} exact>
        <FilterContextProvider>
          <ListContextProvider>
            <ViewContextProvider>
              <ColumnContextProvider>
                <ResultsPage />
              </ColumnContextProvider>
            </ViewContextProvider>
          </ListContextProvider>
        </FilterContextProvider>
      </Route>
    </Switch>
  );
}

function App() {
  useUserTracking(datadogRum, PACKAGE_NAME);

  return (
    <RequireUserAndFlags
      loadingComponent={<Loader />}
      errorComponent={<ErrorPage />}
    >
      <DeprecatedThemeProvider>
        <ManifestProvider css={{ height: '100%' }}>
          <RequireTranslations
            namespace={PACKAGE_NAME}
            translations={translations}
          >
            <>
              <Toaster />
              <Box css={{ height: '100%', isolation: 'isolate' }}>
                <BrowserRouter>
                  <CompatRouter>
                    <Route path="/results">
                      <ShipmentListRoutes />
                    </Route>
                  </CompatRouter>
                </BrowserRouter>
              </Box>
            </>
          </RequireTranslations>
          <ToastContainer />
        </ManifestProvider>
      </DeprecatedThemeProvider>
    </RequireUserAndFlags>
  );
}

export default App;
